import React from 'react';
import PropTypes from 'prop-types';
import { ContextMenu } from "react-contextmenu";
import './DynamicMenu.css';

function DynamicMenu({ content = [], options, onHide, onShow }) {
  const className = options ? options.className : null;

  return (
    <ContextMenu id={`DynamicMenu`} className={`dynamic-menu ${className}`} onHide={onHide} onShow={onShow}>
      { content.map( (x,i) => React.cloneElement(x, { key: `dm-${i}`}) ) }
    </ContextMenu>
  )
}

DynamicMenu.propTypes = {
  content: PropTypes.array.isRequired,
  options: PropTypes.object,
  onHide: PropTypes.func,
  onShow: PropTypes.func
}

export default DynamicMenu;
